window.addEventListener("DOMContentLoaded", (event) => {
  // check if the browser actually supports the <video> element and to only setup the custom controls if it does.
  var supportsVideo = !!document.createElement("video").canPlayType;
  if (supportsVideo) {
    // set up custom controls
    // ...
    const isDesktopWidth = window.innerWidth >= 1024;
    if (isDesktopWidth) {
      var video = document.getElementById("video-desktop");
    } else {
      var video = document.getElementById("video-mobile");
    }
      
    // Check if the video element exists before hiding the default controls
    if (video) {
      video.controls = false;
    }

    // Check if the video wrapper element exists before adding the event listener
    const videoWrapper = document.querySelector(".video-hero__video-wrapper");
    if (videoWrapper) {
      videoWrapper.addEventListener("click", function (event) {
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      });
    }
  }
});
